const SearchScopeDropdown = () => ({
   replace: true,
   templateUrl: '/assets/searchScopeDropdown.html',
   controller: SearchScopeController,
   controllerAs: 'searchScpCtrl',
   scope: {
      fromAdvancedSearch: '<',
      onChange: '&',
      focusMe: '<'
   }
})

class SearchScopeController {
   $scope: any
   searchScopeService: SearchScopeService
   appState: AppStateService
   advanced: AdvancedSearchService
   currentSearchScope?: SearchScope
   isOpen = false
   dialogService: DialogService
   constructor($scope: any, searchScopeService: SearchScopeService, appState: AppStateService, advanced: AdvancedSearchService, dialogService: DialogService) {
      this.$scope = $scope
      this.appState = appState
      this.searchScopeService = searchScopeService
      this.advanced = advanced
      this.dialogService = dialogService
      this.currentSearchScope = this.searchScopeService.currentSearchScope
      this.advanced.on('clearSearchScope', () => {
         // reset the searchscope to 'all' again
         if (this.$scope.fromAdvancedSearch) {
            this.currentSearchScope = this.searchScopeService.getSearchScopeByName('all')
            this.updateState()
         }
      })
      this.searchScopeService.on('clearScopeAsSideEffect', (advancedScopeName = '', callBack?: (goBackToSearchScope: boolean) => void, callbackDateParams?: any) => {
         this.showLeavingSearchScopeAlert(advancedScopeName, callBack, callbackDateParams)
      })
   }

   $onInit() {
      // only update the displayed scope when the appstate really is updated
      this.appState.on('apply', () => {
         this.currentSearchScope = this.searchScopeService.currentSearchScope
      })
   }

   showLeavingSearchScopeAlert(advancedScopeName: string, callBack?: (goBackToSearchScope: boolean) => void, callbackDateParams?: any) {
      if(this.searchScopeService.$uibModalInstance){
         return // we don't want two
      }
      this.searchScopeService.warningMetaData = { fromAdvanced: !!advancedScopeName, scopeLabel: advancedScopeName, callBack, callbackDateParams }
      const isBackdrop = false
      const additionalClass = `${!!advancedScopeName ? ' advanced' : ''}`
      this.searchScopeService.$uibModalInstance = this.dialogService.displayModalDialog(
         this.$scope, 'LeavingSearchScopeModalCtrl', 'leave-search-scope', 'refine/leaveSearchScope.html', isBackdrop, additionalClass
         )
   }

   updateState() {
      this.searchScopeService.updateState(this.currentSearchScope, !this.$scope.fromAdvancedSearch)
      // execute onChange function if provided
      if (angular.isFunction(this.$scope.onChange())) {
         this.$scope.onChange()(this.currentSearchScope)
      }
   }
}

SearchScopeController.$inject = ['$scope', 'searchScopeService', 'appStateService', 'advancedSearchService', 'dialogService']

angular.module('summonApp.directives')
   .controller('searchScopeController', [SearchScopeController])
   .directive('searchScopeDropdown', [ SearchScopeDropdown ])
